import {useContext, useEffect, useMemo, useState} from 'react'
import {DataContext} from '../../../context/DataContext'
import {FilterContext} from '../../../context/FilterContext'
import {Dicionario} from '../../../../../utils/Dicionario'
import {BarChart} from '../../Charts/BarChart'
import {BarChartSingle} from '../../Charts/BarChartSingle'

type Props = {
  label?: string
}

export default function Tipologia({label}: Props) {
  const {data, vsoIdeal, setCacheResult} = useContext(DataContext)
  const {filter} = useContext(FilterContext)
  const [selectedItem, setSelectedItem] = useState(null)

  let {
    chartDataVSOPrograma,
    chartDataVSOProgramaTable,
    estoqueTipologiaDorms,
    vendasPonderadaTipologiasDorms,
    vendasTotalTipologiasDorms,
  } = useMemo(() => {
    let totalUnidadesTipologias = Array(7).fill(0, 0, 7)
    let stockUnidadesTipologias = Array(7).fill(0, 0, 7)
    let totalUnidades = Array(7).fill(0, 0, 7)
    let vsoIdealTipologia = Array(7).fill(0, 0, 7)
    const tempoMedioVenda = Array.from({length: 7}, () => 0)
    const vendasTotalTipologiasDorms = Array.from({length: 7}, () => [])
    const vendasPonderadaTipologiasDorms = Array.from({length: 7}, () => [])
    const estoqueTipologiaDorms = Array.from({length: 7}, () => 0)

    let chartDataVSOPrograma = [
      {
        name: 'Absorção média Mensal',
        data: [],
      },
    ]
    let chartDataVSOProgramaTable = []

    if (data) {
      // eslint-disable-next-line array-callback-return
      data.map((item) => {
        // eslint-disable-next-line array-callback-return
        item.tipologias.map((itemTipologias) => {
          if (itemTipologias.computed) {
            // console.log('asdasdasd')
            // console.log(itemTipologias)
            const totalUnits = Number(itemTipologias.total_units) || 0
            const stockValue = Number(itemTipologias.stock) || 0

            //if (itemTipologias.original_price > 0.1) {
            let bedroomIndex = itemTipologias.bedrooms
            if (itemTipologias.bedrooms === 0) {
              bedroomIndex = 1
            }

            // if (!Number.isFinite(vendasTotalTipologiasDorms[bedroomIndex])) {
            // vendasTotalTipologiasDorms[bedroomIndex] = []
            // }
            vendasTotalTipologiasDorms[bedroomIndex].push(totalUnits - stockValue)

            // console.log('bedroomIndex:', bedroomIndex, '=', totalUnits - stockValue)
            // console.log('vendasTotalTipologiasDorms:',totalUnits - stockValue)
            // if (vendasPonderadaTipologiasDorms[bedroomIndex]) {
            //   vendasPonderadaTipologiasDorms[bedroomIndex] = []
            // }
            vendasPonderadaTipologiasDorms[bedroomIndex].push(
              itemTipologias.venda_mensal * (totalUnits - stockValue)
            )

            // if (estoqueTipologiaDorms[bedroomIndex]) {
            //   estoqueTipologiaDorms[bedroomIndex] = 0
            // }

            estoqueTipologiaDorms[bedroomIndex] = estoqueTipologiaDorms[bedroomIndex] + stockValue

            totalUnidadesTipologias[bedroomIndex] =
              totalUnidadesTipologias[bedroomIndex] + Number(itemTipologias.total_units)
            stockUnidadesTipologias[bedroomIndex] =
              stockUnidadesTipologias[bedroomIndex] + Number(itemTipologias.stock)
            totalUnidades[bedroomIndex] =
              totalUnidades[bedroomIndex] + Number(itemTipologias.total_units)
            // data.fase_projeto_ideal
            vsoIdealTipologia[bedroomIndex] += Math.floor(
              (vsoIdeal[item.fase_projeto_ideal].vso / 100) * Number(itemTipologias.total_units)
            )
            if (!Number.isFinite(tempoMedioVenda[bedroomIndex])) {
              tempoMedioVenda[bedroomIndex] = 0
            }

            tempoMedioVenda[bedroomIndex] +=
              itemTipologias.meses_mercado * (totalUnits - stockValue)

            //  }
          }
        })
      })

      // console.log('totalUnidadesTipologiasxxx')
      // console.log(totalUnidadesTipologias)
      // eslint-disable-next-line array-callback-return
      totalUnidadesTipologias.map((data, index) => {
        const id = `Performance_${index}`

        if (totalUnidadesTipologias[index] > 0) {
          // console.log('dormitorios:', index)
          // let vso = Math.round(
          //   ((totalUnidadesTipologias[index] - stockUnidadesTipologias[index]) /
          //     totalUnidades[index]) *
          //     100
          // )

          // let vsoIdeal = Math.round((vsoIdealTipologia[index] / totalUnidades[index]) * 100)
          // chartDataVSOPrograma[0].data.push({
          //   x: `${index}Q ${index === 1 ? 'single' : ''}`,
          //   y: vso,
          //   total_unidades: totalUnidadesTipologias[index],
          //   id: id,
          // })

          const vendamesalpoderada = vendasPonderadaTipologiasDorms[index].reduce((acc, curr) => {
            return acc + curr
          }, 0)
          // console.log('vendamesalpoderada:', vendamesalpoderada)
          // console.log()
          // console.log('vendasTotalTipologiasDorms[index]:', vendasTotalTipologiasDorms[index])
          const totalvendasporfaixa = vendasTotalTipologiasDorms[index].reduce((acc, curr) => {
            // console.log('acc', acc)
            // console.log('curr', curr)

            return acc + curr
          }, 0)
          // console.log('totalvendasporfaixa:', totalvendasporfaixa)
          // console.log('totalvendasporfaixa---')
          // console.log(totalvendasporfaixa)

          const tempoMedioVendaPonderado = tempoMedioVenda[index] / totalvendasporfaixa

          const vendaMediaMesalPonderada = totalvendasporfaixa / tempoMedioVendaPonderado

          // const vendaMediaMesalPonderada = vendamesalpoderada / totalvendasporfaixa
          // console.log('vendaMediaMesalPonderada:', vendaMediaMesalPonderada)
          // console.log('vendaMediaMesalPonderada')
          // console.log(vendaMediaMesalPonderada)

          // console.log('estoqueTipologiaDorms[indexDorms]')
          // console.log(estoqueTipologiaDorms[indexDorms])

          const mesesAbsorcao =
            estoqueTipologiaDorms[index] > 0
              ? (estoqueTipologiaDorms[index] / vendaMediaMesalPonderada).toFixed(1)
              : '-'
          // console.log('estoqueTipologiaDorms[index] :', estoqueTipologiaDorms[index])
          // console.log('mesesAbsorcao:', mesesAbsorcao)
          // return {
          //   mesesAbsorcao: Number(mesesAbsorcao).toFixed(0),
          //   tipologia: indexDorms,
          //   estoque: estoqueTipologiaDorms[indexDorms],
          //   vendaMensal: vendaMediaMesalPonderada.toFixed(0),
          // }

          chartDataVSOProgramaTable.push({
            domitorios: `${index}Q ${index === 1 ? 'single' : ''}`,
            total_unidades: totalUnidadesTipologias[index],
            estoque: stockUnidadesTipologias[index],
            vendidas: totalUnidadesTipologias[index] - stockUnidadesTipologias[index],
            mesesAbsorcao: mesesAbsorcao,
            vendaMensal: vendaMediaMesalPonderada.toFixed(1),
            id: id,
          })

          chartDataVSOPrograma[0].data.push({
            x: `${index}Q ${index === 1 ? 'single' : ''}`,
            y: Number(vendaMediaMesalPonderada.toFixed(1)),
            total_unidades: Number(vendaMediaMesalPonderada.toFixed(1)),
            id: id,
          })
        }
      })
    }

    return {
      chartDataVSOPrograma,
      chartDataVSOProgramaTable,
      estoqueTipologiaDorms,
      vendasPonderadaTipologiasDorms,
      vendasTotalTipologiasDorms,
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, vsoIdeal])

  useEffect(() => {
    setCacheResult((prev) => ({
      ...prev,
      absorcaoTipologias: chartDataVSOProgramaTable,
    }))
  }, [chartDataVSOProgramaTable, setCacheResult])

  // const absorcaoTipologias = estoqueTipologiaDorms.map((item, indexDorms) => {
  //   // console.log('indexDorms---')
  //   // console.log(indexDorms)

  //   const vendamesalpoderadaporfaixa = vendasPonderadaTipologiasDorms[indexDorms].reduce(
  //     (acc, curr) => {
  //       return acc + curr
  //     },
  //     0
  //   )
  //   // console.log('vendamesalpoderadaporfaixa---')
  //   // console.log(vendamesalpoderadaporfaixa)
  //   const totalvendasporfaixa = vendasTotalTipologiasDorms[indexDorms].reduce((acc, curr) => {
  //     return acc + curr
  //   }, 0)
  //   // console.log('totalvendasporfaixa---')
  //   // console.log(totalvendasporfaixa)
  //   const vendaMediaMesalPonderada = vendamesalpoderadaporfaixa / totalvendasporfaixa

  //   // console.log('vendaMediaMesalPonderada')
  //   // console.log(vendaMediaMesalPonderada)

  //   // console.log('estoqueTipologiaDorms[indexDorms]')
  //   // console.log(estoqueTipologiaDorms[indexDorms])

  //   const mesesAbsorcao =
  //     estoqueTipologiaDorms[indexDorms] > 0
  //       ? (estoqueTipologiaDorms[indexDorms] / vendaMediaMesalPonderada).toFixed(1)
  //       : '-'
  //   return {
  //     mesesAbsorcao: Number(mesesAbsorcao).toFixed(0),
  //     tipologia: indexDorms,
  //     estoque: estoqueTipologiaDorms[indexDorms],
  //     vendaMensal: vendaMediaMesalPonderada.toFixed(1),
  //   }
  // })

  // useEffect(() => {
  //   cacheResult.performanceResumoMercado.vsoPrograma = {
  //     chartData: chartDataVSOPrograma,
  //     tableData: chartDataVSOProgramaTable,
  //   }
  //   setCacheResult(cacheResult)
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [chartDataVSOPrograma])

  if (!data) {
    return <>Carregando..</>
  }
  if (filter.segmentacaoArea === null || filter.segmentacaoPreco === null) {
    return <>Carregando..</>
  }

  return (
    <BarChartSingle
      className={'primary'}
      title={'Venda Média Mensal '}
      subtitle={'Unidades por mês'}
      data={chartDataVSOPrograma}
      onChange={(id: number) => {
        setSelectedItem(id)
      }}
    >
      <table className='table  table-row-dashed table-row-gray-300 table-hover'>
        <thead>
          <tr className='text-dark fw-bold'>
            {chartDataVSOProgramaTable && chartDataVSOProgramaTable.length > 0
              ? Object.entries(chartDataVSOProgramaTable[0]).map((item, index) => {
                  return item[0] !== 'id' ? (
                    <th className='text-center' key={index}>
                      {Dicionario.translate(item[0])}
                    </th>
                  ) : null
                })
              : null}
          </tr>
        </thead>
        <tbody>
          {chartDataVSOProgramaTable
            ? chartDataVSOProgramaTable.map((item, index) => {
                return (
                  <tr key={index} className={item.id === selectedItem ? 'select-data-table' : ''}>
                    <td className='text-center'>{item.domitorios}</td>
                    <td className='text-center'>{item.total_unidades}</td>
                    <td className='text-center'>{item.estoque}</td>
                    <td className='text-center'>{item.vendidas}</td>
                    <td className='text-center'>{item.mesesAbsorcao}</td>
                    <td className='text-center'>{item.vendaMensal}</td>
                  </tr>
                )
              })
            : null}
        </tbody>
      </table>
    </BarChartSingle>
  )
}
